<mat-drawer-container autosize>
  <mat-drawer-content class="example-container" autosize>
    <mat-sidenav-container class="example-container-sidenav">
      @if (isAuthenticated) {
        <div>
          @if (appLabel) {
            <div class="container">
              <nav class="navbar navbar-brand bg-body-tertiary">
                <div class="container-fluid">
                  <img class="btm-logo navbar-left navbar-brand" src="assets/images/cibmtr_logo.png" alt="CIBMTR Logo" />
                  <div>
                    <span class="CIBMTR-Reporting-label"> {{appLabel}} </span>
                  </div>
                  <div class="btns">
                    @if (showBackButton) {
                      <button class="logout-button" (click)="goBack()">Back</button>
                    }
                    @if (showBackButton) {
                      <br />
                    }
                    <button class="logout-button" (click)="logout()">Logout</button>
                  </div>
                </div>
              </nav>
            </div>
          }
          <app-spinner></app-spinner>
          <app-processing-overlay />
          <router-outlet></router-outlet>
          @if (appLabel) {
            <span class="version">version {{versionInfo}}</span>
          }
        </div>
      }
      <mat-sidenav #buttonsidebar mode="side" opened="opened" position="end" class="example-sidenav-content">
        <app-sidebarbutton></app-sidebarbutton>
      </mat-sidenav>
    </mat-sidenav-container>
  </mat-drawer-content>

  <mat-drawer class="sidebarcontainer" #sidenav mode="side" position="end">
    <app-message-tray></app-message-tray>
  </mat-drawer>
</mat-drawer-container>
